import React from 'react';
import { SearchComponentMobileToggle } from '@spothero/search-component';
import { Box, Flex, useBreakpointValue } from '@spothero/ui';
import { useDispatch, useSelector } from 'react-redux';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import MobileViewToggle from 'pages/search/components/search-component/mobile-view-toggle';
import { FilterSelection } from 'pages/search/components/filters/FilterSelection';
import { MobileSearchModal } from '../mobile-search-modal/MobileSearchModal';
import { useShowEventsData } from 'pages/search/hooks/use-show-events-data';
import { setSearchComponentIsOpen } from 'store/search/search-actions';
import { trackSearchEditButtonClicked } from 'segment/events/search-edit-button-clicked';
const ToggleWrapper = ({ onOpen }) => {
    return (<Flex paddingX="4">
            <SearchComponentMobileToggle onClick={onOpen}/>
            <MobileViewToggle />
        </Flex>);
};
export const MobileSearchComponent = () => {
    const isOpen = useSelector((state) => state.search.data.searchComponentIsOpen);
    const { showSEMEvent } = useShowEventsData();
    const reduxState = useReduxSearchState();
    const isMobile = useBreakpointValue({ base: true, tablet: false }, { ssr: false });
    const dispatch = useDispatch();
    const onOpen = () => {
        trackSearchEditButtonClicked({
            parkingType: reduxState.parkingType,
            isMobile,
        });
        dispatch(setSearchComponentIsOpen(true));
    };
    return !isOpen ? (<Box>
            {!showSEMEvent && (<>
                    <ToggleWrapper onOpen={onOpen}/>
                    <FilterSelection />
                </>)}
        </Box>) : (<MobileSearchModal />);
};
